export const PascalCaseSplitRegex = /([a-z0-9])([A-Z])/g; //implements spaces in range of inquiry on CSV results.

declare global {
	// tslint:disable-next-line
	interface String {
		pascalCase(): string;
	}
}

String.prototype.pascalCase = function (this: string) {
	const stringToPascalCase = this ? this : "";
	return stringToPascalCase.replace(PascalCaseSplitRegex, "$1 $2");
};
